import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: 'isNumber',
    standalone: false
})
export class IsNumberPipe implements PipeTransform {
    transform(value: unknown): value is number {
        return typeof value === 'number' && Number.isFinite(value);
    }
}
